import type { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios'

// why: no release o backend fica alguns segundos parado (pm2 stop, migrations, start) e o nginx
// devolve 502/503. A leitura espera e tenta de novo; gravação não se repete, para não duplicar.
// hazard: 504 fica de fora: é consulta lenta que estourou o tempo, repetir só multiplicaria a carga.
export const TENTATIVAS = 8
export const ESPERA_MS = 2500

type ConfigComTentativa = InternalAxiosRequestConfig & { tentativaDeLeitura?: number }

export function deveRepetirLeitura(error: AxiosError, tentativa: number): boolean {
  if (tentativa >= TENTATIVAS) return false
  if ((error.config?.method ?? 'get').toLowerCase() !== 'get') return false
  const status = error.response?.status
  if (status === undefined) return error.code === 'ERR_NETWORK'
  return status === 502 || status === 503
}

export function instalarRepeticaoDeLeitura(api: AxiosInstance, esperaMs = ESPERA_MS) {
  api.interceptors.response.use(undefined, async (error: AxiosError) => {
    const config = error.config as ConfigComTentativa | undefined
    const tentativa = config?.tentativaDeLeitura ?? 0
    if (!config || !deveRepetirLeitura(error, tentativa)) return Promise.reject(error)
    await new Promise((resolve) => setTimeout(resolve, esperaMs))
    return api.request({ ...config, tentativaDeLeitura: tentativa + 1 } as ConfigComTentativa)
  })
}
